import { AccordionSummary } from './index';
import { styled } from '@mui/material/styles';

export const PopperAccordionSummary = styled(AccordionSummary)`
  min-height: 30px;
  padding: 0 8px;
  background-color: ${({ theme }) => theme.palette.grey[100]};
  border-top: 1px solid ${({ theme }) => theme.palette.grey[300]};
  border-bottom: 1px solid ${({ theme }) => theme.palette.grey[300]};

  flex-direction: row-reverse;
  & .MuiAccordionSummary-expandIconWrapper.Mui-expanded {
    transform: rotate(90deg);
  }
  & .MuiAccordionSummary-content {
    margin: 0;
  },
`;
